import { Grid } from "@mui/material"
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useState } from "react"
import { Formik } from "formik"
import { validationSchemaAdminUser } from "helpers/validationSchema"
import { formatDate } from "helpers/functions"
import AdminUserForm from "./adminUserForm/index"
import { useDispatch } from "react-redux"
import { uploadFrontlineUserAction } from "redux/superAdmin/actions"
import { useHistory } from "react-router-dom"

const initialValues = {
  fullName: "",
  email: "",
  contactNumber: "",
  address: "",
  role: "",
  hireDate: null,
  reportingManager: ""
}

const AddAdminLineUser = () => {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const [initialFormValue] = useState(initialValues)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
  }, [])

  function handleSubmit(values) {
    const payload = {
      full_name: values?.fullName,
      email: values?.email,
      country_code: "+1",
      mobile: values?.contactNumber,
      emp_job_class: values?.role,
      address: values?.address,
      hire_date: values?.hireDate ? formatDate(new Date(values?.hireDate)) : null,
      cms_access: true,
      analytics_access: true,
      raffle_access: false
    }
    const handleRoute = () => {
      history.replace("/super-admin/dashboard/admin-user-list")
    }
    dispatch(uploadFrontlineUserAction({ payload, onClose: handleRoute, user_type: "ADMIN" }))
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Header title="Add Admin User" breadCrumbs={breadCrumbs}></Header>
        </Grid>
      </Grid>
      <Formik
        enableReinitialize={true}
        onSubmit={handleSubmit}
        validationSchema={validationSchemaAdminUser}
        initialValues={initialFormValue}>
        {(formik) => <AdminUserForm formik={formik}></AdminUserForm>}
      </Formik>
    </>
  )
}

export default AddAdminLineUser
